import { createRouter } from '@tanstack/react-router';

import { RootProviders } from '~/app/root-providers';
import { RouteError } from '~/app/route-error';
import { NotFound } from '~/app/not-found';

import { routeTree } from './routeTree.gen';

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  scrollRestoration: true,
  defaultErrorComponent: RouteError,
  defaultNotFoundComponent: NotFound,
  InnerWrap: RootProviders,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
